import React from "react";
import { Button, Image, Card, Typography, Space, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { SafetyOutlined, ThunderboltOutlined, CheckCircleOutlined } from "@ant-design/icons";
import logo from "./assets/img_1.png";
import "./HomePage.css";

const { Title, Paragraph } = Typography;

const HomePage = () => {
    const navigate = useNavigate();

    return (
        <div className="homepage-container">
            <Card
                className="welcome-card"
                variant={"borderless"}
            >
                <Space direction="vertical" size="medium" style={{ width: '100%', textAlign: 'center' }}>
                    <div className="logo-container">
                        <div className="logo-wrapper">
                            <Image
                                src={logo}
                                alt="Hijra Bank Logo"
                                preview={false}
                                className="bank-logo"
                            />
                        </div>
                    </div>

                    <Title level={1} className="welcome-title">
                        Welcome to Hijra Bank
                    </Title>

                    <Paragraph className="welcome-subtitle">
                        National ID to Account Integration Portal
                    </Paragraph>

                    <Button
                        type="primary"
                        size="large"
                        className="cta-button"
                        onClick={() => navigate("/acctVerf")}
                        icon={<CheckCircleOutlined />}
                    >
                        Get Started
                    </Button>

                </Space>
            </Card>
        </div>
    );
};

export default HomePage;

